<div>
    <ejs-richtexteditor
        #defaultRTE
        [(ngModel)]="htmlContent"
        id="{{ id }}"
        [toolbarSettings]="tools"
        [quickToolbarSettings]="quickTools"
        [insertImageSettings]="insertImageSettings"
        [height]="height"
        [enableHtmlSanitizer]="false"
        [enableResize]="true"
        (imageUploadSuccess)="uploadSuccess($event)"
    >
    </ejs-richtexteditor>
</div>
